import React, { Component } from 'react';
import $ from 'jquery';
import { Panel,Table,Button } from 'react-bootstrap';

class WordRow extends Component {
  
  render() {
    
    const word = this.props.word;
    const answer = this.props.answer;
    const answered = this.props.answered;
    const english_right = word.english === answer.english;
    
    var tense_right = false;
    if (word.past_tense.includes('/')) {
      if (word.past_tense.split('/').indexOf(answer.past_tense)>-1) {
        tense_right = true;
      } else {
        tense_right = false;
      }
    } else {
        tense_right = word.past_tense === answer.past_tense;
    }
    
    var participle_right = false;
    if (word.past_participle.includes('/')) {
      if (word.past_participle.split('/').indexOf(answer.past_participle)>-1) {
        participle_right = true;
      } else {
        participle_right = false;
      }
    } else {
        participle_right = word.past_participle === answer.past_participle;
    }
    
    if (answered) {
      var answer_english = <span style={{"color":english_right?("green"):("red")}}>{answer.english}</span>;
      var answer_tense = <span style={{"color":tense_right?("green"):("red")}}>{answer.past_tense}</span>;
      var answer_participle = <span style={{"color":participle_right?("green"):("red")}}>{answer.past_participle}</span>;
      return (
        <tr>
          <td>{ word.unit  }</td>
          <td>{ word.chinese }</td>
          <td>{ answer_english }&nbsp;|&nbsp;{ word.english }</td>
          <td>{ answer_tense }&nbsp;|&nbsp;{ word.past_tense }</td>
          <td>{ answer_participle }&nbsp;|&nbsp;{ word.past_participle }</td>
        </tr>
      )
      } else {
        return (
          <tr>
            <td>{ word.unit  }</td>
            <td>{ word.chinese }</td>
            <td><input type="text" id={word.id+'__english'} onChange={this.props.onInputChange}/></td>
            <td><input type="text" id={word.id+'__past_tense'} onChange={this.props.onInputChange}/></td>
            <td><input type="text" id={word.id+'__past_participle'} onChange={this.props.onInputChange}/></td>
          </tr>
        )
      }
  }

}


/* 不规则动词测试 */
class IrregularTest extends Component {

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      test_data: [],
      answers: [],
      results: [],
      grades: [],
      grade: 0,
      answered: false,
    };
    this.gradeChange = this.gradeChange.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  gradeChange(event) {
    const grade = event.target.value;
    var test_data = [];
    var answers = [];
    var results = [];
    this.state.data.map((word)=>{
      if (word.grade === grade) {
        test_data.push(word);
        results.push({'id':word.id,'english':false,'past_tense':false,'past_participle':false});
        answers.push({'id': word.id,
                      'english': '',
                      'past_tense': '',
                      'past_participle': ''}
        );
      }
    });
    this.setState({test_data:test_data,answers:answers,answered:false,results:results,grade:event.target.value});
  }

  onInputChange(event) {
    var id = event.target.id.split('__')[0];
    const field_type = event.target.id.split('__')[1];
    id = parseInt(id,10);
    const val = event.target.value.trim();
    var answers = this.state.answers;
    answers.find(a=>a.id===id)[field_type] = val;
    var test_data = this.state.test_data;
    var results = this.state.results;
    if (test_data.find(a=>a.id===id)[field_type]===val) {
      results.find(r=>r.id===id)[field_type] = true
    } else {
      if (test_data.find(a=>a.id===id)[field_type].includes('/')){
        if (test_data.find(a=>a.id===id)[field_type].split('/').indexOf(val)>-1) {
          results.find(r=>r.id===id)[field_type] = true
        } else {
          results.find(r=>r.id===id)[field_type] = false
        }
      } else {
        results.find(r=>r.id===id)[field_type] = false
      }
    }
    this.setState({answers:answers,results:results});
  }

  componentDidMount() {
    var that = this;
    $(function(){$.ajax({
      url: URL + 'api/irregulars/',
      headers: {},
      type: "GET",
      dataType: "json",
      success: function(data) {
        var grades=[];
        data.forEach((d)=>{
          if (grades.indexOf(d.grade)===-1) {
            grades.push(d.grade);
          }
        });
        that.setState({data:data,grades:grades})
      },
      error: function(xhr, status, err) {
        console.log(err.Message);
        alert('Error:'+err.Message);
      } 
    })});
  }

  onSubmit(event) {
    if (event.target.innerHTML==='检查'){
      this.setState({answered:true,})
    } else {
      let new_test_data = [];
      let test_data = this.state.test_data;
      let results = this.state.results;
      let new_results = [];
      let new_answers = [];
      /* 看看有没有错的单词 */
      results.forEach((r)=>{
        if (!(r.english && r.past_tense && r.past_participle)) {
          new_test_data.push(test_data.find(a=>a.id===r.id));
          new_results.push({'id':r.id,'english':false,'past_tense':false,'past_participle':false});
          new_answers.push({'id':r.id,'english':'','past_tense':'','past_participle':''})
        }
      });
      if (new_test_data.length===0) { /*没有错的，根据当前选择的年级重新加载*/
        const grade = this.state.grade;
        var test_data = [];
        var answers = [];
        var results = [];
        this.state.data.map((word)=>{
          if (word.grade === grade) {
            test_data.push(word);
            results.push({'id':word.id,'english':false,'past_tense':false,'past_participle':false});
            answers.push({'id': word.id,
                          'english': '',
                          'past_tense': '',
                          'past_participle': ''}
            );
          }
        });
        this.setState({answers:answers,answered:false,results:results,test_data:test_data})
      } else { /*有错的*/
        this.setState({test_data:new_test_data,answers:new_answers,results:new_results,answered:false})
      }
    }
  }

  render() {
    const gradeOptions = this.state.grades.map((grade,index)=>
      <option key={index} value={grade}>{grade}</option>
      );
    var rows = [];
    if (this.state.test_data.length>0){
      this.state.test_data.forEach((word)=>{
        var answer = this.state.answers.find(x=>x.id===word.id);
        rows.push(
            <WordRow 
              answered={this.state.answered}
              word={word}
              answer={answer}
              onInputChange={this.onInputChange}
            />
        )
      })
    }
    return(
      <Panel>
        <Panel.Heading>
          不规则动词测试&nbsp;&nbsp;&nbsp;
            <select name="grade_select" onChange={this.gradeChange}>
            <option key={100} value='请选择年级'>请选择年级</option>
            { gradeOptions }
          </select>
        </Panel.Heading>
        <Panel.Body>
          <Table striped hover>
            <thead>
              <tr>
                <th>单元</th><th>中文</th>
                <th>单词</th><th>过去式</th><th>过去分词</th>
              </tr>
            </thead>
            <tbody>
              { rows }
            </tbody>
          </Table>
        </Panel.Body>
        <Panel.Footer>
          {this.state.test_data.length>0?(<Button onClick={this.onSubmit}>{this.state.answered?('再试一次'):('检查')}</Button>):''}
        </Panel.Footer>
      </Panel>
    )
  }
}


export default IrregularTest;



// WEBPACK FOOTER //
// ./src/Irregular_Test.js